import Vue from 'vue'
import App from './App.vue'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/saga-blue/theme.css';   
import 'primevue/resources/primevue.min.css';   
import 'primeicons/primeicons.css';	 

import reactiveStorage from "vue-reactive-storage";
 
// import TabMenu from 'primevue/tabmenu';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
// import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
// import Password from 'primevue/password';
import Card from 'primevue/card';
// import ProgressSpinner from 'primevue/progressspinner';

// import DataTable from 'primevue/datatable';
// import Column from 'primevue/column';
// import Menu from 'primevue/menu';
// import Menubar from 'primevue/menubar';

import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';

import Dialog from 'primevue/dialog';

import FileUpload from 'primevue/fileupload';

// import Image from 'primevue/image';

import Message from 'primevue/message';

// import Toast from 'primevue/toast';
// // import ToastService from 'primevue/toastservice';

// import Dropdown from 'primevue/dropdown';

// // import InputGroup from 'primevue/inputgroup';
// import ContextMenu from 'primevue/contextmenu';
// import VirtualScroller from 'primevue/virtualscroller';
// import Listbox from 'primevue/listbox';

import Editor from 'primevue/editor';

import VueSimpleContextMenu from 'vue-simple-context-menu'
Vue.component('vue-simple-context-menu', VueSimpleContextMenu)

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(reactiveStorage, {
  "token": null,
});

Vue.use(PrimeVue);

// Vue.component('TabMenu', TabMenu);
Vue.component('InputText', InputText);
Vue.component('InputNumber', InputNumber );
// Vue.component('Textarea', Textarea);
Vue.component('Button', Button);
// Vue.component('Password', Password);
Vue.component('Card', Card);
// Vue.component('ProgressSpinner', ProgressSpinner);
// Vue.component('DataTable', DataTable);
// Vue.component('Column', Column);
// Vue.component('Menu', Menu);
// Vue.component('Menubar', Menubar);
Vue.component('Splitter', Splitter );
Vue.component('SplitterPanel', SplitterPanel );
Vue.component('Dialog', Dialog );
Vue.component('FileUpload', FileUpload );
// Vue.component('Image', Image );
// Vue.component('Toast', Toast );
Vue.component('Message', Message );
// Vue.component('Dropdown', Dropdown );
// // Vue.component('InputGroup', InputGroup );
// Vue.component('ContextMenu', ContextMenu );
// Vue.component('VirtualScroller', VirtualScroller );
// Vue.component('Listbox', Listbox );
Vue.component('Editor', Editor );


new Vue({
  render: h => h(App),
}).$mount('#app')
